module.exports = __webpack_public_path__ + "img/icon_tj_cy.789a2c53.png";